// extracted by mini-css-extract-plugin
export var bodyRow = "_ds-d";
export var cardColumns = "_ds-e";
export var ellipsesOverflow = "_ds-2";
export var flatBottomCorners = "_ds-3";
export var flatTopCorners = "_ds-4";
export var headerActionsDropdown = "_ds-f";
export var headerBottomRow = "_ds-c";
export var headerTopRow = "_ds-b";
export var orderDetailsWrapper = "_ds-0";
export var orderInfoContainer = "_ds-1";
export var productDetails = "_ds-9";
export var productImage = "_ds-5";
export var responsiveTable = "_ds-8";
export var shipmentContainer = "_ds-a";
export var tableBottomLeft = "_ds-6";
export var tableBottomRight = "_ds-7";
export var trackingLink = "_ds-g";